/*
 * SolGrat – variante si poze pe pagina de produs
 *
 * 1) Previzualizare varianta (doar mobil/tableta): deasupra butoanelor de variante apare
 *    o caseta cu desenul/poza variantei alese. Se schimba instant la click, FARA sa
 *    deruleze pagina (derularea automata se batea cu tema si pagina sarea sus-jos).
 *    Tap pe caseta -> urca la galeria mare.
 * 2) Tema pune focus pe butonul variantei dupa reincarcare; focus-ul se face fara scroll.
 * 3) Fallback: daca varianta NU are poza atasata, cauta poza al carei ALT contine
 *    valoarea optiunii (ex. "HSS M2", "HW (K40)", "80 mm").
 */
(() => {
  const norm = (s) => (s || "").toString().toLowerCase().replace(/\s+/g, "");

  // --- stil caseta ---
  const style = document.createElement("style");
  style.textContent = `
    .sg-variant-preview { display: none; }
    @media (max-width: 989px) {
      .sg-variant-preview.is-ready {
        display: flex; align-items: center; gap: 12px;
        margin: 0 0 12px; padding: 8px;
        border: 1px solid rgba(var(--color-border, 221,225,230), 1);
        border-radius: 6px; background: #fff; cursor: pointer;
      }
      .sg-variant-preview img {
        width: 132px; height: 96px; object-fit: contain; flex: 0 0 auto;
        background: #fff; border-radius: 4px;
      }
      .sg-variant-preview-text { font-size: 1.3rem; line-height: 1.35; }
      .sg-variant-preview-label { display: block; opacity: .7; font-size: 1.2rem; }
      .sg-variant-preview-title { display: block; font-weight: 600; }
    }
  `;
  document.head.appendChild(style);

  // --- focus fara scroll pentru butoanele de varianta ---
  let noScrollFocusUntil = 0;
  const originalFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options) {
    if (
      Date.now() < noScrollFocusUntil &&
      this.closest &&
      this.closest("variant-radios, variant-selects")
    ) {
      return originalFocus.call(this, Object.assign({}, options, { preventScroll: true }));
    }
    return originalFocus.call(this, options);
  };

  const findMediaId = (gallery, variant) => {
    if (!gallery || !variant || !Array.isArray(variant.options)) return null;

    const title = norm(gallery.getAttribute("data-product-title"));
    const options = variant.options.map(norm).filter(Boolean);
    let bestId = null;
    let bestScore = 0;

    gallery.querySelectorAll(".product-media-main[data-media-id]").forEach((el) => {
      const alt = norm(el.dataset.mediaAlt);
      if (!alt || alt === title) return;

      let score = 0;
      options.forEach((ov) => {
        if (alt.includes(ov) || ov.startsWith(alt)) score += 1;
      });

      if (score > bestScore) {
        bestScore = score;
        bestId = el.dataset.mediaId;
      }
    });

    return bestId;
  };

  const imageForVariant = (gallery, variant) => {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.preview_image) {
      const src = variant.featured_media.preview_image.src;
      if (src) return src + (src.includes("?") ? "&" : "?") + "width=300";
    }
    const mediaId = findMediaId(gallery, variant);
    if (!mediaId || !gallery) return null;
    const img = gallery.querySelector(`.product-media-main[data-media-id="${mediaId}"] img`);
    return img ? img.currentSrc || img.src : null;
  };

  const variantHasOwnImage = (picker) =>
    [...picker.querySelectorAll('script[type="application/json"][data-resource]')].some((s) => {
      try {
        const v = JSON.parse(s.textContent);
        return !!(v && v.featured_media);
      } catch (e) {
        return false;
      }
    });

  const labelText = () => {
    const lang = (document.documentElement.lang || "ro").slice(0, 2);
    if (lang === "uk") return "Обраний варіант";
    if (lang === "en") return "Selected option";
    if (lang === "pl") return "Wybrany wariant";
    return "Varianta aleasă";
  };

  const updatePreview = (picker, variant) => {
    const gallery = document.getElementById(`MediaGallery-${picker.dataset.section}`);
    const block = picker.closest(".product-block-variants") || picker.parentElement;
    if (!gallery || !block) return;

    let box = block.previousElementSibling;
    if (!box || !box.classList.contains("sg-variant-preview")) {
      box = document.createElement("div");
      box.className = "sg-variant-preview";
      box.innerHTML =
        '<img alt="" loading="lazy"><span class="sg-variant-preview-text">' +
        '<span class="sg-variant-preview-label"></span>' +
        '<span class="sg-variant-preview-title"></span></span>';
      box.addEventListener("click", () => {
        const target = gallery.querySelector(".product-media-main-wrapper") || gallery;
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      block.parentNode.insertBefore(box, block);
    }

    const src = imageForVariant(gallery, variant);
    if (!src) {
      box.classList.remove("is-ready");
      return;
    }

    box.querySelector("img").src = src;
    box.querySelector("img").alt = variant.title || "";
    box.querySelector(".sg-variant-preview-label").textContent = labelText();
    box.querySelector(".sg-variant-preview-title").textContent = variant.title || "";
    box.classList.add("is-ready");
  };

  const currentVariantOf = (picker) => {
    const checked = picker.querySelector("fieldset input:checked, select option:checked");
    if (!checked) return null;
    const script = picker.querySelector(
      `script[type="application/json"][data-resource="${checked.id}"]`,
    );
    try {
      return script ? JSON.parse(script.textContent) : null;
    } catch (e) {
      return null;
    }
  };

  const mainPickers = () =>
    [...document.querySelectorAll('variant-radios[data-update-url="true"], variant-selects[data-update-url="true"]')].filter(
      (p) => !p.closest("quick-view-drawer, custom-bundle-quickview"),
    );

  // La incarcare: caseta doar daca produsul are poze pe variante (sau gasite dupa ALT).
  const init = () => {
    mainPickers().forEach((picker) => {
      const gallery = document.getElementById(`MediaGallery-${picker.dataset.section}`);
      const variant = currentVariantOf(picker);
      if (variantHasOwnImage(picker) || (variant && findMediaId(gallery, variant))) {
        picker.dataset.sgPreview = "true";
        updatePreview(picker, variant);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // La click pe varianta: actualizare instant, fara derulare.
  document.addEventListener("change", (event) => {
    const picker = event.target.closest?.("variant-radios, variant-selects");
    if (!picker || picker.dataset.updateUrl !== "true") return;
    if (picker.closest("quick-view-drawer, custom-bundle-quickview")) return;

    noScrollFocusUntil = Date.now() + 4000;

    if (picker.dataset.sgPreview === "true") {
      updatePreview(picker, picker.currentVariant);
    }
  });

  // Fallback dupa ALT in galeria mare pentru variantele fara poza atasata.
  const onVariantChange = ({ sectionId, variant } = {}) => {
    if (!variant || variant.featured_media) return;

    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    const mediaId = findMediaId(gallery, variant);

    if (mediaId && typeof gallery.setActiveMedia === "function") {
      gallery.setActiveMedia(mediaId, gallery.getAttribute("hide-variants") === "true");
    }
  };

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.productVariantChange, onVariantChange);
  }
})();
